import { bugReportId } from '../config/constants.js';

export default () => {
    const bugReport = $$(bugReportId);
    bugReport.destructor();
};
